<template>
  <div>
    <div
      class="h-100 click py-2"
      v-if="p._id"
      @click="view()"
      style="min-width: 160px; max-width: 100%"
    >
      <div class="border">
        <b-img-lazy
          class="img-fluid w-100"
          :src="getImage(p.image, 'small')"
        ></b-img-lazy>
      </div>

      <div class="px-2 py-1 position-relative">
        <div
          class="badge badge-info rounded-0 py-2 position-absolute px-3 promo-badge"
          style="top: -90px; left: 0px"
          v-if="getPromoSummary(p)"
        >
          <span style="font-size: 12px"> {{ getPromoSummary(p) }} </span>
          <span class="d-none promo-detail">{{ getPromo(p.value, p.promos) }}</span>
        </div>
        <div
          class="badge badge-info rounded-0 py-2 position-absolute px-3 promo-badge"
          style="top: -160px; right: 0px"
          v-if="p.available_on && getAvailable(p.available_on) !== ''"
        >
          <span style="font-size: 12px"> </span>
          <span class="d-none1 promo-detail">{{
            getAvailable(p.available_on)
          }}</span>
        </div>
        <div
          class="badge badge-warning rounded-0 py-2 position-absolute w-100 category-badge"
          style="top: -120px; left: 0px"
          v-if="p.stock !== false && p.stock < 1"
        >
          <span style="font-size: 12px"> SIN STOCK </span>
        </div>
        <div
          class="badge badge-secondary rounded-0 position-absolute px-3"
          style="top: -40px; left: 0px"
        >
          <span style="font-size: 12px">
            {{ (p.category && p.category.name) || "Sin Categoria" }}
          </span>
        </div>
        <div
          class="badge badge-danger rounded-0 position-absolute"
          style="top: -20px; right: 0px"
        >
          <small
            class="d-block text-secondary px-2 pt-1"
            v-if="getCardDiscountedPrice(p) < p.value"
          >
            <s>${{ formatNumber(p.value) }}</s>
          </small>
          <span style="font-size: 12px" class="d-block px-2 pb-1">
            ${{ formatNumber(getCardDiscountedPrice(p)) }}
          </span>
        </div>
        <div class="overflow-hidden pt-2">
          <span
            class="card-title text-uppercase font-weight-bold pr-2 product-title"
          >
            {{ p.name }}
          </span>
        </div>
      </div>
      <div class="align-self-end w-100 px-2 mb-2 d-none">
        <div class="row">
          <div class="col-md-5 ml-auto">
            <router-link
              class="btn btn-outline-success text-center d-block btn-sm"
              :to="getLink(`producto/${p._id}`)"
            >
              <b-icon icon="cart" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "id"],
  data() {
    return {
      p: {},
    };
  },
  mounted() {
    if (!this.data) this.load();
    else this.p = this.data;
  },
  methods: {
    getPromoSummary(product = {}) {
      const promos = (product.promos || []).filter((promo) => promo && promo.enabled);
      if (promos.length === 0) return "";

      const [promo] = promos;
      if (promo.to == "product") {
        return `Ahora $${this.formatNumber(product.value - promo.discount)}`;
      }
      if (promo.to == "total" && promo.when == "qty") {
        if (promo.in == "%") return `${promo.discount}% dcto desde ${promo.value} un.`;
        if (promo.in == "$") return `-$${this.formatNumber(promo.discount)} desde ${promo.value} un.`;
      }
      if (promo.to == "total" && promo.when == "total") {
        if (promo.in == "%") return `${promo.discount}% dcto sobre $${this.formatNumber(promo.value)}`;
        if (promo.in == "$") return `-$${this.formatNumber(promo.discount)} sobre $${this.formatNumber(promo.value)}`;
      }
      if (promo.to == "option") {
        if (promo.in == "%" && Number(promo.discount) === 100) {
          return promo.value
            ? `Extra gratis desde $${this.formatNumber(promo.value)}`
            : "Extra gratis";
        }
        return promo.when == "minopcion" && promo.value
          ? `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} en extras`
          : `${promo.in == "%" ? promo.discount + "%" : "-$" + this.formatNumber(promo.discount)} en opciones`;
      }
      return "Oferta";
    },
    getCardDiscountedPrice(product = {}) {
      const promos = (product.promos || []).filter((promo) => promo && promo.enabled);
      const productPromo = promos.find((promo) => promo.to == "product");
      if (!productPromo) return product.value || 0;
      return Math.max((product.value || 0) - (productPromo.discount || 0), 0);
    },
    getAvailable(values) {
      let rs = "";

      if (values.length == 1) {
        const [value] = values;
        if (value == "pickup") rs = "Solo retiro";
        if (value == "delivery") rs = "Solo Delivery";
        if (value == "shipping") rs = "Solo Envio";
      } 
      //else {
      //   values.forEach((value) => {
      //     if (value == "pickup") rs += "Retiro";
      //     if (value == "delivery") rs += "Relivery";
      //     if (value == "shipping") rs += "Envio";
      //   });
      // }

      return rs;
    },
    getPromo(value = 0, promos) {
      let rs = "";

      promos.forEach((promo) => {
        if (!promo.enabled) return;
        if (promo.to == "product")
          rs += `$${value - promo.discount} sobre ${promo.value}` + " \n";
        if (promo.to == "total")
          rs += `-$${promo.discount} al total sobre $${promo.value}` + " \n";
        if (promo.to == "option")
          rs += (
            promo.when == "minopcion" && promo.value
              ? `${promo.in == "$" ? "-$" : ""}${promo.discount}${
                  promo.in == "%" ? "%" : ""
                } en extras desde $${this.formatNumber(promo.value)}`
              : `${promo.in == "$" ? "-$" : ""}${promo.discount}${
                  promo.in == "%" ? "%" : ""
                } en opciones extra`
          ) + " \n";
        // console.log({ promo });
      });
      return rs;
    },
    view() {
      console.log("uwu");
      // push query pid
      this.$router.push({
        query: { pid: this.p._id },
      });
    },
    load() {
      const pid = this.id;
      const { webName: _id } = this.$store.state.info;
      this.$http
        .get(`${_id}/product/${pid}`)
        .then((res) => {
          this.p = res.data.data;
          //this.$store.commit("setProduct", res.data.data);
          console.log(res.data.data);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
